export default {
    isActive:false,
    errorMessage:null,
    many:null,
    isStringMessage: null,
    isNormalMessage: null,
}